module.exports = __webpack_public_path__ + "img/layer.08658d67.png";